import { render, staticRenderFns } from "./AudioSpectrum.vue?vue&type=template&id=30a3f366&scoped=true"
import script from "./AudioSpectrum.vue?vue&type=script&lang=js"
export * from "./AudioSpectrum.vue?vue&type=script&lang=js"
import style0 from "./AudioSpectrum.vue?vue&type=style&index=0&id=30a3f366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a3f366",
  null
  
)

export default component.exports